import type { FC, ReactNode } from 'react'
import type { StageMode } from '@/types'
import type { TrackId } from '@/constants/studio'

import { useState } from 'react'
import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import HeroSection from '@/components/landing/hero-section'
import BenefitsSection from '@/components/landing/benefits-section'
import ClassesSection from '@/components/landing/classes-section'
import StepsSection from '@/components/landing/steps-section'
import QuoteSection from '@/components/landing/quote-section'
import FaqSection from '@/components/landing/faq-section'
import TrialSection from '@/components/landing/trial-section'
import MobileTrialBar from '@/components/landing/mobile-trial-bar'

const Home: FC = (): ReactNode => {
    const [mode, setMode] = useState<StageMode>('both')
    const [track, setTrack] = useState<TrackId | ''>('')
    const [focusSignal, setFocusSignal] = useState(0)

    const chooseTrack = (next: TrackId): void => {
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

        setTrack(next)
        document.getElementById('trial')?.scrollIntoView({
            behavior: reducedMotion ? 'auto' : 'smooth',
            block: 'start'
        })
        setFocusSignal((value) => value + 1)
    }

    return (
        <Layout>
            <Seo />

            <HeroSection mode={mode} onModeChange={setMode} />
            <BenefitsSection />
            <ClassesSection onChoose={chooseTrack} />
            <StepsSection />
            <QuoteSection />
            <FaqSection />
            <TrialSection track={track} onTrackChange={setTrack} focusSignal={focusSignal} />
            <MobileTrialBar />
        </Layout>
    )
}

export default Home
